import { Component, OnInit } from '@angular/core';

import { AccountService } from './account.service';
import { UserModel } from './user.model';

@Component({
  selector: 'app-account',
  standalone: false,
  templateUrl: './account.component.html',
  styleUrl: './account.component.css'
})
export class AccountComponent implements OnInit {

  user: Partial<UserModel> = {
    name: "",
    email: ""
  }

  constructor(
    private accountService: AccountService
  ){ }

  async ngOnInit(): Promise<void> {
    this.user = await this.accountService.getUserData()
  }

}
